import React from 'react';
import Name from '../../components/ui/Name';
import profile from './profile';

export default {
	fields: {
		...profile.fields,
		fullName: {
			label: `Nom du Média`,
			placeholder: ``,
			helper: ``
		}
	},
	messages: {
		saved: `Média enregistré avec succès !`,
	},
	tab: profile.tab,
	tabs: profile.tabs,
	modales: {
		deleteProfile: {
			title: `Supprimer un média`,
			body: props => (<div>Êtes-vous sûr de vouloir supprimer <span className="modale-profile-name"><Name {...props } /></span> ?<br />Attention cette action est irréversible et ne pourra être annulée.</div>),
			yes: `Supprimer`,
			no: `Annuler`
		},
		addProfile: {
			title: `Ajouter un média`,
			cancel: `Annuler`,
			confirm: `Créer le média`,
			matchingProfiles: `Les médias suivants peuvent correspondre au média que vous souhaitez créer. Si c'est le cas, merci d'éditer la fiche du média correspondant et ne pas créer un nouveau`,
			cgv: `Je certifie que le média que je veux créer n'existe pas déjà.`,
			success: `Média créée avec succès ! Vous pouvez maintenant éditer sa fiche !`,
			search: {
				noResult: ``,
			}
		},
		confirmLightMerge: {
			title: `Lier un compte social à un média`,
			body: profile => (<div>Êtes-vous sûr(e) de vouloir lier ce compte social à <span className="modale-profile-name"><Name {...profile } /></span> ?</div>),
			yes: `Oui, lier`,
			no: `Annuler`
		},
		merge: {
			title: `Fusionner avec...`,
			cancel: `Annuler`,
			matchingProfiles: `Sélectionnez le média avec lequel vous souhaitez fusionner.`,
			merge: `Fusionner`,
			search: {
				noResult: ``,
			}
		},
		confirmMerge: {
			title: `Sélectionner les champs à conserver`,
			confirm: `Fusionner`,
			cancel: `Annuler`,
			emptyProfile: `Champs libres`
		},
		mergeError: {
			title: 'Fusion impossible',
			body: `Désolé, ces 2 médias correspondent à des célébrités distinctes, ou des membres community, et ne peuvent donc pas être fusionnés.`,
			ok: `Ok`,
		},
	}
}
